import { render } from "./App.vue?vue&type=template&id=9ddcaf94"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=9ddcaf94&lang=css"

import exportComponent from "C:\\dev_app\\vue-2e73tr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__